import { RegisterPaymentModal } from '@components'

import { ReactElement, useCallback } from 'react'

import { useVatDeclarationsRegisterPeriodPaymentModal } from '../../context/vatDeclarationsRegisterPaymentModalContext'

export const ModalFooter = (): ReactElement => {
  const { closeModal, submitForm, isProcessing } = useVatDeclarationsRegisterPeriodPaymentModal()

  const handleCancelButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleSubmitButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <RegisterPaymentModal.Footer
      onCancel={handleCancelButtonClick}
      onSubmit={handleSubmitButtonClick}
      isProcessing={isProcessing}
    />
  )
}
